import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/13b0b4c1/src/components/docsLayout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "4-enjoy-useauth",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#4-enjoy-useauth",
        "aria-label": "4 enjoy useauth permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`4. Enjoy useAuth`}</h2>
    <p>{`You're ready to use useAuth for authentication in your React app.`}</p>
    <p>{`Here's a login button for example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const Login = () => {
    const { isAuthenticated, login, logout } = useAuth()

    if (isAuthenticated()) {
        return <Button onClick={logout}>Logout</Button>
    } else {
        return <Button onClick={login}>Login</Button>
    }
}
`}</code></pre>
    <p><inlineCode parentName="p">{`isAuthenticated`}</inlineCode>{` is a method that checks if the user's cookie is still valid.`}</p>
    <p><inlineCode parentName="p">{`login`}</inlineCode>{` and `}<inlineCode parentName="p">{`logout`}</inlineCode>{` trigger their respective actions.`}</p>
    <p>{`You can even say hello to your users:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// src/pages/index.js

const IndexPage = () => {
  const { isAuthenticated, user } = useAuth()

  return (
    <Layout>
      <SEO title="Home" />
      <h1>Hi {isAuthenticated() ? user.name : "people"}</h1>
  )
}
`}</code></pre>
    <p>{`Check `}<inlineCode parentName="p">{`isAuthenticated`}</inlineCode>{` then use the user object. Simple as that.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      